<template>
  <div class="promotion-container d-flex flex-column m-3">
    <div class="d-flex flex-row justify-content-between no-select">
      <div style="color: #1976d2" class="d-flex flex-row">
        <div>
          <i style="font-size: 1rem" class="el-icon-goods"></i>
        </div>
        <div>
          <span class="font-size-9 ml-2">Promotion</span>
        </div>
      </div>
      <button type="button" @click="closeThisPopup">
        <i
          style="font-size: 1.75rem"
          class="el-icon-close button-close-popup"
        ></i>
      </button>
    </div>
    <VuePerfectScrollbar v-if="newRegister" style="height: 90vh">
      <div class="d-flex flex-row justify-content-center align-items-center">
        <div style="margin-top: 0.5rem">
          <img
            src="/promotion/image_2021-04-26_14-09-12.png"
            style="height: 80vh"
          />
        </div>
      </div>
      <div class="d-flex flex-row flex-fill justify-content-center">
        <div
          class="d-flex flex-row align-items-center"
          style="color: white; background-color: #1c1c1c; width: 80vh"
        >
          <div class="d-flex flex-column flex-fill align-items-center">
            <div class="mt-3" id="content">
              <section>
                <ul class="d-flex flex-row" id="countdown">
                  <li>
                    <span class="days timenumbers">01</span>
                    <p class="timeRefDays timedescription">days</p>
                  </li>
                  <li>
                    <span class="hours timenumbers">00</span>
                    <p class="timeRefHours timedescription">hours</p>
                  </li>
                  <li>
                    <span class="minutes timenumbers">00</span>
                    <p class="timeRefMinutes timedescription">minutes</p>
                  </li>
                  <li>
                    <span class="seconds timenumbers yellow-text">00</span>
                    <p class="timeRefSeconds timedescription">seconds</p>
                  </li>
                </ul>
              </section>
            </div>
          </div>
          <div
            class="d-flex flex-row align-items-center"
            style="font-size: 3rem; font-weight: 100; opacity: 0.25"
          >
            |
          </div>
          <div
            @click="
              goRechargeView();
              closeThisPopup();
            "
            class="recharge-now d-flex flex-row align-items-center justify-content-center"
            style="height: 3rem; cursor: pointer; width: 15rem"
          >
            <span>RECHARGE NOW</span>
          </div>
        </div>
      </div>
    </VuePerfectScrollbar>
    <div class="d-flex justify-content-center" v-else>
      <img
        v-if="user.region === 'VN'"
        src="/promotion/cashback_vn.jpg"
        style="height: 80vh"
      />
      <img v-else src="/promotion/cashback.jpg" style="height: 80vh" />
    </div>
  </div>
</template> 

<script>
import "@/assets/css/promotion.scss";
import base from "@/scripts/base";
import moment from "moment";
import { mapState } from "vuex";

export default {
  extends: base,

  data() {
    return {
      newRegister: false,
    };
  },

  computed: {
    ...mapState({
      user: (state) => state.auth.user,
    }),
  },

  mounted() {
    this.countdownPromotion();
  },

  methods: {
    // Go to payment
    goRechargeView() {
      this.$router.push("/recharge");
    },
    //#region Close pop-up
    closeThisPopup() {
      this.closePopup("promotion");
    },
    //#endregion
    countdownPromotion() {
      if (
        this.user.registerAt + 86400000 > moment().valueOf() &&
        this.user.recharged === 0
      ) {
        this.newRegister = true;
      }
      //Provide the plugin settings
      $("#countdown").countdown({
        //The countdown end date
        date: moment(this.user.registerAt)
          .add(1, "days")
          .format("MMM DD YYYY HH:mm:ss"),

        // on (03:07:52) | off (3:7:52) - two_digits set to ON maintains layout consistency
        format: "on",
      });
    },
  },
};
</script> 